import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ContractsPage from "@/pages/admin/ContractsPage";

export const Route = createFileRoute("/_admin/admin/contracts/")({
  head: () => pageHead("Admin · Contracts", "AKIVA admin · contracts portal.", "/admin/contracts", true),
  component: ContractsPage,
});
